import React from 'react';

export const AdultsOnlyBackPositionIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.8 34.1199C15.473 34.1199 17.64 31.953 17.64 29.2799C17.64 26.6069 15.473 24.4399 12.8 24.4399C10.1269 24.4399 7.95996 26.6069 7.95996 29.2799C7.95996 31.953 10.1269 34.1199 12.8 34.1199Z"
        fill="#FF6AA0"
      />
      <path
        d="M24.56 20.34C27.233 20.34 29.4 18.1731 29.4 15.5C29.4 12.827 27.233 10.66 24.56 10.66C21.8869 10.66 19.72 12.827 19.72 15.5C19.72 18.1731 21.8869 20.34 24.56 20.34Z"
        fill="#00A6ED"
      />
      <path
        d="M33 15.1599C41.22 16.9399 47.76 24.04 49.06 32.52C49.44 35.7 49.52 39.22 50.62 42.18C51.64 45.34 53.98 47.06 56.92 48.88C57.6 49.28 57.34 50.38 56.56 50.44C46.48 51.66 41.92 42.42 41.2 33.74C40.06 27.2 36.38 21.72 32.6 15.8399C32.36 15.5399 32.64 15.0599 33.02 15.1599H33Z"
        fill="#00A6ED"
      />
      <path
        d="M12.68 48.6401C12.36 38.6801 21 27.5201 31.94 28.7001C38.72 29.4401 41.54 34.6201 39.06 40.6801C38.56 41.8801 38.18 43.6801 37.82 44.0401C37.76 44.2201 38.2 44.7601 38.94 45.2001C40.46 46.1401 42.62 46.7801 44.78 47.6001C45.22 47.7601 45.44 48.2601 45.26 48.7001C45.16 48.9401 44.98 49.1201 44.76 49.2001C42.5 50.0001 40.18 50.4201 37.46 50.1401C31.38 49.4001 30.24 43.7601 31.72 38.6401C31.94 37.6001 32.08 36.7001 32.04 36.4201C32 36.3201 32 36.4001 32.1 36.6401C32.18 36.8601 32.42 37.0201 32.36 37.0001C24.9 34.2201 17.38 42.3401 13.46 48.8401C13.28 49.2001 12.68 49.0401 12.68 48.6401Z"
        fill="#FF6AA0"
      />
    </svg>
  );
};
